import sharedFilters from './shared';

export default {
  pageFilters: [
    {
      id: 'content',
      label: 'Content',
      filters: {
        show: null
      }
    },
    {
      id: 'users',
      label: 'Users',
      filters: {
        country: null,
        panel: sharedFilters.sampleBalance,
        age: null,
        gender: null
      }
    },
    {
      id: 'date',
      label: 'Date',
      filters: {
        date: null
      }
    },
    {
      id: 'segments',
      label: 'Saved Filters',
      filters: {
        segments: sharedFilters.segments
      }
    }
  ],

  looks: {
    followersByDate: {
      fields: [
        'age',
        'country',
        'date',
        'gender',
        'show',
        'network',
        'genre',
        'panel'
      ]
    },
    showViewerDropOff: {
      fields: [
        'age',
        'country',
        'date',
        'gender',
        'show',
        'network',
        'genre',
        'panel'
      ]
    },
    socialEngagement: {
      fields: [
        'age',
        'country',
        'date',
        'gender',
        'show',
        'network',
        'genre',
        'panel'
      ]
    },
    viewershipSummary: {
      fields: [
        'age',
        'country',
        'date',
        'gender',
        'show',
        'network',
        'genre',
        'panel'
      ]
    },
    engScoreByEpisode: {
      fields: [
        'age',
        'country',
        'date',
        'gender',
        'show',
        'network',
        'genre',
        'panel'
      ]
    }
  }
};
